import React, { FC, PropsWithChildren } from 'react';
import { useSelector } from 'react-redux';
import { Navigate, useLocation } from 'react-router-dom';
import { isBhiAdmin } from 'src/helpers/permissions';
import { selectProfile } from 'src/modules/profile/slices';

const BhiAdminRoute: FC<PropsWithChildren> = ({ children }) => {
  const { profile } = useSelector(selectProfile);
  const location = useLocation();

  if (!profile) {
    return null;
  }

  if (!isBhiAdmin(profile)) {
    return <Navigate to={{ pathname: '/home', search: location.search }} replace />;
  }

  return <>{children}</>;
};

export default BhiAdminRoute;
